import { Locale } from 'modules/i18n';

export const upgradeAccountDialogTranslation = {
  [Locale.en]: {
    title: 'Unlock Premium features',
    description:
      'This functionality comes with the Premium service plan only, along with various other advanced features to supercharge your Web3 projects:',
    item1: 'Ultimate number of blockchains',
    item2: 'Superior rate limits for Node/Advanced APIs',
    item3: 'Standard, Trace, and Debug calls',
    item4: 'Multi-project statistics dashboard',
    item5: 'WSS, Whitelists, and 3 projects',
    getPremium: 'Get Premium',
    cancel: 'Cancel',
  },
};
